/**
 * Percent text <-> parts per million, BY STRING — never through a float, for
 * the same reason money is (money-input.ts): 4.712 * 10000 is not 47120 in
 * binary floating point, and a rate that drifts is a set-aside that drifts.
 *
 * Empty text is "not set" (null), which is a real, different answer from 0%.
 */

export type RateParse = { ok: true; ppm: number | null } | { ok: false; message: string };

export const RATE_MESSAGE = 'Use a percentage like 25 or 4.712, up to 50. Leave blank for not set.';

export function parsePercentToPpm(text: string): RateParse {
  const t = text.trim().replace(/%$/, '').trim();
  if (t === '') return { ok: true, ppm: null };
  const m = /^(\d{1,2})(?:\.(\d{1,4}))?$/.exec(t);
  if (!m) return { ok: false, message: RATE_MESSAGE };
  const ppm = Number(m[1]) * 10_000 + Number((m[2] ?? '').padEnd(4, '0'));
  if (ppm > 500_000) return { ok: false, message: RATE_MESSAGE };
  return { ok: true, ppm };
}

/** 250000 -> "25", 47120 -> "4.712", null -> "". */
export function ppmToPercentText(ppm: number | null): string {
  if (ppm == null) return '';
  const whole = Math.floor(ppm / 10_000);
  const frac = String(ppm % 10_000)
    .padStart(4, '0')
    .replace(/0+$/, '');
  return frac ? `${whole}.${frac}` : String(whole);
}
